import { ApiError } from '@root/globalTypes';
import { queryFetch } from '../api';
import { useQuery } from '@tanstack/react-query';
import { UserWebPushResp } from './types';
import { useAppContext } from '@contexts/app';
import { queryKeys } from '@utils/consts';

export const useGetWebPush = () => {
  const { primaryRole } = useAppContext();

  const { data, error, isPending } = useQuery<UserWebPushResp, ApiError>({
    queryKey: queryKeys.webpushNotifications,
    queryFn: () =>
      queryFetch({
        url: 'webpush_notifications',
      }),
    placeholderData: (previousData) => previousData as UserWebPushResp,
    enabled: Boolean(primaryRole === 'field_user'),
  });

  return {
    data,
    error,
    isLoading: isPending && Boolean(primaryRole === 'field_user'),
  };
};
